import './polyfills'

import { PortalProvider } from '@nobia/zeus-components/lib/portal'
import Root from '@nobia/zeus-components/lib/root'
import { registerServiceWorker } from '@nobia/zeus-components/lib/serviceWorker'
import settings from '@nobia/zeus-components/lib/settings'
import React from 'react'
import ReactDOM from 'react-dom'

import { App } from './app'
import {
  installAuth419FetchInterceptor,
  installAuth419VisibilityRefresh,
} from './app/auth419Recovery'
import GlobalStyles from './styles/global'

installAuth419FetchInterceptor()
installAuth419VisibilityRefresh()

const cacheConfig = {
  typePolicies: {
    Range: {
      keyFields: ['title', 'image'],
    },
    Unit: {
      keyFields: ['title', 'price'],
    },
    Applicances: {
      keyFields: ['title', 'price'],
    },
    Installation: {
      keyFields: ['title', 'price'],
    },
    Worktop: {
      keyFields: ['title', 'price'],
    },
    CustomerProfile: {
      keyFields: ['email'],
    },
    UserQueries: {
      fields: {
        messages: {
          keyArgs: false,
          merge(existing = [], incoming, { args: { skip } }) {
            if (!skip) {
              return [...incoming]
            }
            return [...existing, ...incoming]
          },
        },
      },
    },
  },
}

const renderApp = () => {
  ReactDOM.render(
    <Root
      apiUrl={settings.gatewayAPI}
      brand={settings.brand}
      basename={settings.basename}
      cacheConfig={cacheConfig}
      persistSharedState
    >
      <PortalProvider>
        <GlobalStyles />
        <App />
      </PortalProvider>
    </Root>,
    document.getElementById('root')
  )
}

renderApp()
registerServiceWorker()

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./app', renderApp)
}
